/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useRef, useEffect } from "react";
import useLocalStorage from "../hooks/useLocalStorage";

function UserTasks() {
  const [loaded, setloaded] = useState(false);
  const isMounted = useRef(false);
  const [widgetSetting] = useLocalStorage(
    "widgetSetting",
    null
  );
  const [loadedWidgets, setLoadedWidgets] = useState([]);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = widgetSetting.widgetHost + "?v=" + new Date().getTime();
    script.async = true;
    script.onload = () => {
      setloaded(true);
    };
    document.body.appendChild(script);
    isMounted.current = true;

    //unmount - ondestory
    return () => {
      setloaded(false);

      document.body.removeChild(script);
    };
  }, [widgetSetting]);

  useEffect(() => {
    if (loaded) {
      const widget = new UserTasksWidget({
        mount: "usertasks",
        widget: "USERTASKS",
        widgetSettings: {
          token: widgetSetting.token,
          showTitle: widgetSetting.showTitle,
          endPoint: widgetSetting.endPoint,
          hideTabs: !widgetSetting.hideTabs,
          hideFilter: !widgetSetting.hideFilter,
          organizationId: widgetSetting.organizationId,
          appId: widgetSetting.appId,
          environment: widgetSetting.environment,
          appsyncGraphqlEndpoint: widgetSetting.appsyncGraphqlEndpoint,
          customFormsUrl: widgetSetting.customFormsUrl,
        },
        taskConfig: {
          id: null,
        },
      });
      const newwidgets = loadedWidgets;
      newwidgets.push(widget);
      setLoadedWidgets(newwidgets);
    }
    return () => {
      if (loadedWidgets.length > 0) {
        loadedWidgets.forEach((widget) => {
          if (widget && widget.unmount) {
            widget.unmount();
          }
        });
      }
    };
  }, [loaded, widgetSetting]);

  return <div id="usertasks" style={{ width: "100%", height: "100%" }}></div>;
}

export default UserTasks;
